import { Input } from 'antd';
const { TextArea } = Input;

// If char count pass "showCount" in props
const MyTextArea = (props) => {
    const { onChange = ()=>{}, ...rest } = props;
    const handleChange = (e) => {
        // console.log(e, " MyTextArea");
        onChange(e.target.value);
    }
  return (
    <TextArea 
        rows={4}
        // value={value}
        placeholder="Write your response here"           
        maxLength={500}
        onChange={handleChange}
        autoSize={{
          minRows: 4,
          maxRows: 5,
        }}
        {...rest} 
    />
  )
}

export default MyTextArea;